import LocalStorage from '../../../../defined/localStorage';
import { translate } from '../../../../helper';
import { Utils } from '../../../../utils';
import { signin } from '../Slice/authSlice';
import { logoutCleanup } from '../../../../utils/logoutCleanup';

const isDT = window.location.pathname.includes('dealer-technician');
const endpointType = isDT ? 'dealerTechnicianEndpoints' : 'userMobileEndpoints';

export const login = (values, setSubmitting, navigate, dispatch, onError, callback) => {
    const { email, password } = values;
    const dataToSend = {
        username: email,
        password
    };
    Utils.api.postApiCall(
        Utils.EndPoint[endpointType].loginApi,
        dataToSend,
        (respData) => {
            const { data } = respData;
            Utils.showAlert(1, data.message || 'Login Success!!');
            callback(data);
            dispatch(signin({ data: data }));

            LocalStorage.setItem(LocalStorage.DEFINE_KEY.ACCESS_TOKEN, data.token);
            LocalStorage.setItem(LocalStorage.DEFINE_KEY.JWT_TOKEN, data.jwt_token);
            LocalStorage.setItem(LocalStorage.DEFINE_KEY.ROLE, data?.user?.role);
            LocalStorage.setItem(LocalStorage.DEFINE_KEY.USER_EMAIL, email);
            const postLoginUrl = Utils.EndPoint[endpointType].createOrder;

            window.location.replace(postLoginUrl);
            setSubmitting(false);
        },
        (error) => {
            const { data } = error;
            console.error(data);
            onError(data);
            Utils.showAlert(2, data?.non_field_errors?.[0] || 'Invalid Credentials');
            setSubmitting(false);
        }
    );
};

export const signup = (values, setSubmitting, navigate, dispatch, callback) => {
    Utils.api.postApiCallForm(
    Utils.EndPoint[endpointType].signupApi,
    values,
    (respData) => {
            const { data } = respData;
            callback(data);
            dispatch(signin({ data: data }));
            LocalStorage.setItem(LocalStorage.DEFINE_KEY.ACCESS_TOKEN, data.token);
            LocalStorage.setItem(LocalStorage.DEFINE_KEY.JWT_TOKEN, data.jwt_token);
            LocalStorage.setItem(LocalStorage.DEFINE_KEY.ROLE, values.get('role'));
            LocalStorage.setItem(LocalStorage.DEFINE_KEY.USER_EMAIL, values.get('email'));
            Utils.showAlert(1,translate('accountSuccess'));
            navigate(Utils.EndPoint[endpointType].profile);
    },
    (error) => {
      const { data } = error
      Utils.showAlert(2, data?.email[0] || 'Some error');
      setSubmitting(false)
    }
  )
}

export const sendOTPAPI = (values, setSubmitting, navigate, dispatch) => {
    Utils.api.postApiCall(
        Utils.EndPoint[endpointType].getOTP,
        values,
        () => {
            Utils.showAlert(1, 'OTP has been sent to your Email ID');
        },
        () => {
            Utils.showAlert(2, 'Failed to send the OTP, try again later');
        }
    );
};

export const sendOTPInSignUp = (values, sunccessCallback) => {
    Utils.api.postApiCall(
        Utils.EndPoint[endpointType].sendOTPAPI,
        values,
        () => {
            sunccessCallback()
            Utils.showAlert(1, 'OTP has been sent to your Mobile');
        },
        () => {
            Utils.showAlert(2, 'Failed to send the OTP, try again later');
        }
    );
}

export const verifyOTPAPI = (values, navigate) => {
    Utils.api.postApiCall(
        Utils.EndPoint[endpointType].validateOTP,
        values,
        (respData) => {
            const { data: { token } } = respData;
            Utils.showAlert(1, 'OTP has been verifed');
            navigate(Utils.EndPoint[endpointType].reset_password, { state: { token } });
        },
        (error) => {
            console.error('err', error);
            const { data } = error;
            Utils.showAlert(2, 'Entered OTP is wrong try again');
        }
    );
};

export const verifyOTPAPISignUp = (values, sunccessCallback) => {
    Utils.api.postApiCall(
        Utils.EndPoint[endpointType].verifyOTPAPI,
        values,
        (respData) => {
            Utils.showAlert(1, 'OTP has been verifed');
            sunccessCallback()
        },
        (error) => {
            const { data } = error;
            Utils.showAlert(2, 'Entered OTP is wrong try again');
        }
    );
};

export const resetPassAPI = (values, navigate, forgotPass = false, dispatch) => {
    return new Promise((resolve, reject) => {
        Utils.api.postApiCall(
            Utils.EndPoint[endpointType].resetPassAPI,
            values,
            () => {
                Utils.showAlert(1, "Password changed successfully")
                if (forgotPass) {
                    logoutCleanup({ dispatch, navigate, endpointType });
                } else {
                    navigate(Utils.EndPoint[endpointType].settings);
                }
                resolve();
            },
            (error) => {
                console.error('err', error);
                const { data } = error;
                reject(data);
                Utils.showAlert(2, Object.values(data)?.[0]?.[0]||"OOPS! something went wrong!")
                
            }
        );
    });
};

export const deleteAccountAPI = (onSuccess) => {
    Utils.api.deleteApiCall(
        Utils.EndPoint[endpointType].deleteAPI,
        '',
        () => {
            Utils.showAlert(1, 'Account has been deleted');
            onSuccess?.();
        },
        (error) => {
            console.error('err', error);
            const { data } = error;
            Utils.showAlert(2, data?.detail || data);
        }
    );
};

export const resendEmailOtpForSignup = (values, sunccessCallback, errorCallback) => {
    Utils.api.postApiCall(
        Utils.EndPoint[endpointType].resendEmailOtp,
        values,
        (res) => {
            sunccessCallback && sunccessCallback(res);
        },
        (err) => {
            Utils.showAlert(2, 'Failed to send the OTP, try again later');
            errorCallback && errorCallback(err);
        }
    );
};

export const verifyEmailOtpForSignup = (values, sunccessCallback, setOverlayLoading) => {
    Utils.api.postApiCall(
        Utils.EndPoint[endpointType].validateEmailOtp,
        values,
        () => {
            Utils.showAlert(1, 'Email verified successfully');
            sunccessCallback && sunccessCallback();
        },
        (error) => {
            const { data } = error || {};
            Utils.showAlert(2, data?.detail || 'Entered OTP is wrong, try again');
            setOverlayLoading && setOverlayLoading(false);
        }
    );
};

export const googleLogin = async (code, navigate, dispatch, role = 'user',callback, setIsRedirecting) => {
  Utils.api.postApiCall(
    'accounts/google/login/',
    {
      code,
      role
    },
    (respData) => {
      const { data } = respData;
      callback(data);
      dispatch(signin({ data }));
      LocalStorage.setItem(LocalStorage.DEFINE_KEY.ACCESS_TOKEN, data.token);
      LocalStorage.setItem(LocalStorage.DEFINE_KEY.JWT_TOKEN, data.jwt_token);
      LocalStorage.setItem(LocalStorage.DEFINE_KEY.ROLE, role);
      LocalStorage.setItem(LocalStorage.DEFINE_KEY.USER_EMAIL, data.user?.email);
      setIsRedirecting && setIsRedirecting(false)
      sessionStorage.removeItem('OAUTH_IN_PROGRESS');
      navigate(Utils.EndPoint[endpointType].createOrder);
    },
    (error) => {
      const { data } = error || {};
      Utils.showAlert(2, data?.detail || data?.error || 'Google login failed');
      setIsRedirecting && setIsRedirecting(false)
      sessionStorage.removeItem('OAUTH_IN_PROGRESS');
      navigate(Utils.EndPoint[endpointType].auth);
    }
    );
};


export const appleLogin = async (code, navigate, dispatch, role = 'user', callback , first_name, last_name) => {

  Utils.api.postApiCall(
    'accounts/apple/login/',
    {
      code,
      role,
      first_name,
      last_name
    },
    (respData) => {

      const { data } = respData;
      callback && callback(data);

      dispatch(signin({ data }));

      LocalStorage.setItem(LocalStorage.DEFINE_KEY.ACCESS_TOKEN, data.token);
      LocalStorage.setItem(LocalStorage.DEFINE_KEY.JWT_TOKEN, data.jwt_token);
      LocalStorage.setItem(LocalStorage.DEFINE_KEY.ROLE, role);
      LocalStorage.setItem(LocalStorage.DEFINE_KEY.USER_EMAIL, data.user?.email);
      sessionStorage.removeItem('OAUTH_IN_PROGRESS');
      const postLoginUrl = Utils.EndPoint[endpointType].createOrder;
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

      if (isStandalone) {
            window.location.replace(postLoginUrl);
      } else {
            navigate(postLoginUrl);
        }
    },
    (error) => {

      const { data } = error || {};
      Utils.showAlert(2, data?.detail || data?.error || 'Apple login failed');
      sessionStorage.removeItem('OAUTH_IN_PROGRESS');
      navigate(Utils.EndPoint[endpointType].auth);
    }
  );
};
